import script from "./GameReviewView.vue?vue&type=script&setup=true&lang=js"
export * from "./GameReviewView.vue?vue&type=script&setup=true&lang=js"

import "./GameReviewView.vue?vue&type=style&index=0&id=a2e7f9ac&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2e7f9ac"]])

export default __exports__